import { render, staticRenderFns } from "./sensor-management.component.vue?vue&type=template&id=76584ade"
import script from "./sensor-management.component.ts?vue&type=script&lang=js&external"
export * from "./sensor-management.component.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76584ade')) {
      api.createRecord('76584ade', component.options)
    } else {
      api.reload('76584ade', component.options)
    }
    module.hot.accept("./sensor-management.component.vue?vue&type=template&id=76584ade", function () {
      api.rerender('76584ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/iot-simulator/sensor-management.component.vue"
export default component.exports